import React from "react";
import InvoiceAccountClientInformationController from "../../../../Controllers/AdminScreens/Invoices/Accounts/InvoiceAccountClientInformationController";
import { useNavigate } from "react-router-dom";
import LoadingSkeleton from "../../../../../Components/LoadingSkeleton";

const InvoiceAccountClientInformationScreen = () => {

  const {
    clientInvoiceInfo,
    loading, error,
    hasPermission,
    navEstimateListPage, navInvoiceListPage, navReceiptListPage
  } = InvoiceAccountClientInformationController();

  return (
    <>
      <div style={{ width: '93%', margin: 'auto' }}>
        <h3 style={styles.header}>
          <div style={styles.headerContainer} >
            {/* <img
              src={backIcon}
              alt="Back"
              style={{ width: '25px', height: '25px', cursor: 'pointer', marginRight: '10px' }}
              onClick={handleBack}
            /> */}
            <span>Accounts</span>
          </div>
        </h3>
      </div>
      <div style={styles.container}>

      <h3 style={styles.categoryHeader}>{clientInvoiceInfo?.client_info?.client_name || '--'}</h3>
        <div className="custom-checkbox-container" style={{ marginBottom: "12px" }}>
          <h3 style={{ ...styles.sectionTitle, }}>Client Information</h3>
          {error && <div className="list-error-msg">{error} </div>}
        </div>

        <div style={styles.row}>
        <div style={styles.staticField}>
            <label style={styles.label}>File No.</label>
            <span style={styles.staticValue}>{loading ? <LoadingSkeleton width="90%" height="8px" /> : clientInvoiceInfo?.client_info?.client_file_id || '--'} </span>
          </div>
          <div style={styles.staticField}>
            <label style={styles.label}>Client Name</label>
            <span style={styles.staticValue}>{loading ? <LoadingSkeleton width="90%" height="8px" /> : clientInvoiceInfo?.client_info?.client_name || '--'} </span>
          </div>
          <div style={styles.staticField}>
            <label style={styles.label}>Client Type</label>
            <span style={styles.staticValue}>{loading ? <LoadingSkeleton width="90%" height="8px" /> : clientInvoiceInfo?.client_info?.client_type_name || '--'}</span>
          </div>
          {/* <div style={styles.staticField}>
            <label style={styles.label}>Date of Invoice</label>
            <span style={styles.staticValue}>{clientInvoiceInfo?.client_info?.dateOfInvoice}</span>
          </div> */}
          {/* <div style={styles.staticField}>
            <label style={styles.label}>Invoice Number</label>
            <span style={{ ...styles.staticValue, textDecoration: 'underline', color: '#5A55D2' }}>{clientInvoiceInfo?.client_info?.invoiceNumber}</span>
          </div> */}
          {/* <div style={styles.staticField}>
            <label style={styles.label}>Combined Bill</label>
            <span style={styles.staticValue}>{clientInvoiceInfo?.client_info?.combinedBill}</span>
          </div>
          <div style={styles.staticField}>
            <label style={styles.label}>Group Invoice</label>
            <span style={styles.staticValue}>{clientInvoiceInfo?.client_info?.groupInvoice}</span>
          </div> */}
          <div style={styles.staticField}>
            <label style={styles.label}>Team Leader</label>
            <span style={styles.staticValue}>{loading ? <LoadingSkeleton width="90%" height="8px" /> : clientInvoiceInfo?.client_info?.team_leader_name || '--'}</span>
          </div>
          <div style={styles.staticField}>
            <label style={styles.label}>Client Assigned User</label>
            <span style={styles.staticValue}>{loading ? <LoadingSkeleton width="90%" height="8px" /> : clientInvoiceInfo?.client_info?.emp_id_incharge_name || '--'}</span>
          </div>
          <div style={styles.staticField}>
            <label style={styles.label}>Group Name</label>
            <span style={styles.staticValue}>{loading ? <LoadingSkeleton width="90%" height="8px" /> : clientInvoiceInfo?.client_info?.group_name || '--'}</span>
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '93%', margin: 'auto', columnGap: '15px',paddingBottom:30 }}>
        <div style={styles.card} className="card-invoice-summary">
          <div style={styles.heading}>Summary</div>
          <div style={{ ...styles.item, backgroundColor: '#F7F8FA', padding: '25px 16px' }}>
            <span style={styles.cardLable}>Opening Balance</span>
            <span style={styles.cardAmount}>{loading ? <LoadingSkeleton width="50px" height="8px" /> : clientInvoiceInfo?.summary_info?.opening_bal || '--'}</span>
          </div>
          <div style={{ ...styles.item, padding: '25px 16px' }}>
            <span style={styles.cardLable}>Invoiced Amount</span>
            <span style={styles.cardAmount}>{loading ? <LoadingSkeleton width="50px" height="8px" /> : clientInvoiceInfo?.summary_info?.invoiced_amount || '--'}</span>
          </div>
          <div style={{ ...styles.item,backgroundColor: '#F7F8FA', padding: '25px 16px' }}>
            <span style={styles.cardLable}>Amount Paid</span>
            <span style={styles.cardAmount}>{loading ? <LoadingSkeleton width="50px" height="8px" /> : clientInvoiceInfo?.summary_info?.amount_paid || '--'}</span>
          </div>
          <div style={{ ...styles.item, padding: '25px 16px' }}>
            <span style={styles.cardLable}>Pending Payment</span>
            <span style={styles.cardAmount}>{loading ? <LoadingSkeleton width="50px" height="8px" /> : clientInvoiceInfo?.summary_info?.pending_payment || '--'}</span>
          </div>
        </div>
        <div style={{ display: 'flex',  flexWrap: 'wrap',marginTop:25,flex:'auto', gap: '15px' }}>
        <div style={{...styles.card2}} className="card-invoice-summary" >
          <div style={styles.heading}>Invoice</div>
          <div style={{ ...styles.item, backgroundColor: '#F7F8FA', padding: '25px 16px' }}>
            <span style={styles.cardLable}>Generated</span>
            <span onClick={()=>{ clientInvoiceInfo?.invoices_info?.generated_count && navInvoiceListPage('generated_count')}} style={{ ...styles.cardAmount, textDecoration:clientInvoiceInfo?.invoices_info?.generated_count ? 'underline' : 'none', cursor:clientInvoiceInfo?.invoices_info?.generated_count && hasPermission(["invoice_create", "invoice_edit", "invoice_del"]) ? 'pointer' : 'not-allowed', color: '#5A55D2' }}>{loading ? <LoadingSkeleton width="50px" height="8px" /> : (typeof clientInvoiceInfo?.invoices_info?.generated_count === "number" && !isNaN(clientInvoiceInfo?.invoices_info?.generated_count)) ? (clientInvoiceInfo?.invoices_info?.generated_count < 10 ? `0${clientInvoiceInfo?.invoices_info?.generated_count}` : clientInvoiceInfo?.invoices_info?.generated_count) : clientInvoiceInfo?.invoices_info?.generated_count || '--'}</span>
          </div>
          <div style={{ ...styles.item, padding: '25px 16px' }}>
            <span style={styles.cardLable}>Upcoming</span>
            <span onClick={()=>{clientInvoiceInfo?.invoices_info?.upcoming_count && navInvoiceListPage('upcoming_count')}} style={{ ...styles.cardAmount, textDecoration:clientInvoiceInfo?.invoices_info?.upcoming_count ? 'underline' : 'none', cursor:clientInvoiceInfo?.invoices_info?.upcoming_count && hasPermission(["invoice_create", "invoice_edit", "invoice_del"]) ? 'pointer' : 'not-allowed', color: '#5A55D2' }}>{loading ? <LoadingSkeleton width="50px" height="8px" /> : (typeof clientInvoiceInfo?.invoices_info?.upcoming_count === "number" && !isNaN(clientInvoiceInfo?.invoices_info?.upcoming_count)) ? (clientInvoiceInfo?.invoices_info?.upcoming_count < 10 ? `0${clientInvoiceInfo?.invoices_info?.upcoming_count}` : clientInvoiceInfo?.invoices_info?.upcoming_count) : clientInvoiceInfo?.invoices_info?.upcoming_count || '--'}</span>
          </div>
          <div style={{ ...styles.item, backgroundColor: '#F7F8FA', padding: '25px 16px' }}>
            <span style={styles.cardLable}>Deleted</span>
            <span onClick={()=>{clientInvoiceInfo?.invoices_info?.deleted_count && navInvoiceListPage('deleted_count')}} style={{ ...styles.cardAmount, textDecoration:clientInvoiceInfo?.invoices_info?.deleted_count ? 'underline' : 'none', cursor:clientInvoiceInfo?.invoices_info?.deleted_count && hasPermission(["invoice_create", "invoice_edit", "invoice_del"]) ? 'pointer' : 'not-allowed', color: '#5A55D2' }}>{loading ? <LoadingSkeleton width="50px" height="8px" /> : (typeof clientInvoiceInfo?.invoices_info?.deleted_count === "number" && !isNaN(clientInvoiceInfo?.invoices_info?.deleted_count)) ? (clientInvoiceInfo?.invoices_info?.deleted_count < 10 ? `0${clientInvoiceInfo?.invoices_info?.deleted_count}` : clientInvoiceInfo?.invoices_info?.deleted_count) : clientInvoiceInfo?.invoices_info?.deleted_count || '--'}</span>
          </div>
        </div>
     
        <div style={{...styles.card2}} className="card-invoice-summary" >
          <div style={styles.heading}>Receipts</div>
          <div style={{ ...styles.item, backgroundColor: '#F7F8FA', padding: '25px 16px' }}>
            <span style={styles.cardLable}>Generated</span>
            <span onClick={()=>{clientInvoiceInfo?.reciepts_info?.generated_count && navReceiptListPage('generated_count')}} style={{ ...styles.cardAmount, textDecoration:clientInvoiceInfo?.reciepts_info?.generated_count ? 'underline' : 'none', cursor:clientInvoiceInfo?.reciepts_info?.generated_count && hasPermission(["receipt_gen", "receipt_edit"]) ? 'pointer' : 'not-allowed', color: '#5A55D2' }}>{loading ? <LoadingSkeleton width="50px" height="8px" /> : (typeof clientInvoiceInfo?.reciepts_info?.generated_count === "number" && !isNaN(clientInvoiceInfo?.reciepts_info?.generated_count)) ? (clientInvoiceInfo?.reciepts_info?.generated_count < 10 ? `0${clientInvoiceInfo?.reciepts_info?.generated_count}` : clientInvoiceInfo?.reciepts_info?.generated_count) : clientInvoiceInfo?.reciepts_info?.generated_count || '--'}</span>
          </div>
          <div style={{ ...styles.item, padding: '25px 16px' }}>
            <span style={styles.cardLable}>Pending</span>
            <span onClick={()=>{clientInvoiceInfo?.reciepts_info?.pending_count && navInvoiceListPage('pending_count')}} style={{ ...styles.cardAmount, textDecoration:clientInvoiceInfo?.reciepts_info?.pending_count ? 'underline' : 'none', cursor:clientInvoiceInfo?.reciepts_info?.pending_count && hasPermission(["invoice_create", "invoice_edit", "invoice_del"]) ? 'pointer' : 'not-allowed', color: '#5A55D2' }}>{loading ? <LoadingSkeleton width="50px" height="8px" /> : (typeof clientInvoiceInfo?.reciepts_info?.pending_count === "number" && !isNaN(clientInvoiceInfo?.reciepts_info?.pending_count)) ? (clientInvoiceInfo?.reciepts_info?.pending_count < 10 ? `0${clientInvoiceInfo?.reciepts_info?.pending_count}` : clientInvoiceInfo?.reciepts_info?.pending_count) : clientInvoiceInfo?.reciepts_info?.pending_count || '--'}</span>
          </div>
          <div style={{ ...styles.item, backgroundColor: '#F7F8FA', padding: '25px 16px' }}>
            <span style={styles.cardLable}>Overdue</span>
            <span onClick={()=>{clientInvoiceInfo?.reciepts_info?.overdue_count && navInvoiceListPage('overdue_count')}} style={{ ...styles.cardAmount, textDecoration:clientInvoiceInfo?.reciepts_info?.overdue_count ? 'underline' : 'none', cursor:clientInvoiceInfo?.reciepts_info?.overdue_count && hasPermission(["invoice_create", "invoice_edit", "invoice_del"]) ? 'pointer' : 'not-allowed', color: '#5A55D2' }}>{loading ? <LoadingSkeleton width="50px" height="8px" /> : (typeof clientInvoiceInfo?.reciepts_info?.overdue_count === "number" && !isNaN(clientInvoiceInfo?.reciepts_info?.overdue_count)) ? (clientInvoiceInfo?.reciepts_info?.overdue_count < 10 ? `0${clientInvoiceInfo?.reciepts_info?.overdue_count}` : clientInvoiceInfo?.reciepts_info?.overdue_count) : clientInvoiceInfo?.reciepts_info?.overdue_count || '--'}</span>
          </div>
        </div>
        <div style={{...styles.card2}} className="card-invoice-summary" >
          <div style={styles.heading}>Estimates</div>
          <div style={{ ...styles.item, backgroundColor: '#F7F8FA', padding: '25px 16px' }}>
            <span style={styles.cardLable}>Generated</span>
            <span onClick={()=>{clientInvoiceInfo?.estimates_info?.generated_count && navEstimateListPage('generated_count')}} style={{ ...styles.cardAmount, textDecoration:clientInvoiceInfo?.estimates_info?.generated_count ? 'underline' : 'none', cursor:clientInvoiceInfo?.estimates_info?.generated_count && hasPermission(["estimate_create", "estimate_edit", "estimate_del"]) ? 'pointer' : 'not-allowed', color: '#5A55D2' }}>{loading ? <LoadingSkeleton width="50px" height="8px" /> : (typeof clientInvoiceInfo?.estimates_info?.generated_count === "number" && !isNaN(clientInvoiceInfo?.estimates_info?.generated_count)) ? (clientInvoiceInfo?.estimates_info?.generated_count < 10 ? `0${clientInvoiceInfo?.estimates_info?.generated_count}` : clientInvoiceInfo?.estimates_info?.generated_count) : clientInvoiceInfo?.estimates_info?.generated_count || '--'}</span>
          </div>
          <div style={{ ...styles.item, padding: '25px 16px' }}>
            <span style={styles.cardLable}>Converted</span>
            <span onClick={()=>{clientInvoiceInfo?.estimates_info?.converted_count && navEstimateListPage('converted_count')}} style={{ ...styles.cardAmount, textDecoration:clientInvoiceInfo?.estimates_info?.converted_count ? 'underline' : 'none', cursor:clientInvoiceInfo?.estimates_info?.converted_count && hasPermission(["estimate_create", "estimate_edit", "estimate_del"]) ? 'pointer' : 'not-allowed', color: '#5A55D2' }}>{loading ? <LoadingSkeleton width="50px" height="8px" /> : (typeof clientInvoiceInfo?.estimates_info?.converted_count === "number" && !isNaN(clientInvoiceInfo?.estimates_info?.converted_count)) ? (clientInvoiceInfo?.estimates_info?.converted_count < 10 ? `0${clientInvoiceInfo?.estimates_info?.converted_count}` : clientInvoiceInfo?.estimates_info?.converted_count) : clientInvoiceInfo?.estimates_info?.converted_count || '--'}</span>
          </div>
          <div style={{ ...styles.item, backgroundColor: '#F7F8FA', padding: '25px 16px' }}>
            <span style={styles.cardLable}>Deleted</span>
            <span onClick={()=>{ clientInvoiceInfo?.estimates_info?.deleted_count && navEstimateListPage('deleted_count')}} style={{ ...styles.cardAmount, textDecoration:clientInvoiceInfo?.estimates_info?.deleted_count ? 'underline' : 'none', cursor:clientInvoiceInfo?.estimates_info?.deleted_count && hasPermission(["estimate_create", "estimate_edit", "estimate_del"]) ? 'pointer' : 'not-allowed', color: '#5A55D2' }}>{loading ? <LoadingSkeleton width="50px" height="8px" /> : (typeof clientInvoiceInfo?.estimates_info?.deleted_count === "number" && !isNaN(clientInvoiceInfo?.estimates_info?.deleted_count)) ? (clientInvoiceInfo?.estimates_info?.deleted_count < 10 ? `0${clientInvoiceInfo?.estimates_info?.deleted_count}` : clientInvoiceInfo?.estimates_info?.deleted_count) : clientInvoiceInfo?.estimates_info?.deleted_count || '--'}</span>
          </div>
        </div>
        </div>
    
      </div>
    </>
  )

}

const styles = {
  container: {
    padding: "20px",
    maxWidth: "90%",
    margin: "auto",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
  title: {
    fontSize: "28px",
    marginBottom: "23px",
    fontWeight: "500",
    color: "#1F384C",
    fontFamily: "Roboto Slab"
  },
  section: {
    marginBottom: "21px",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "500",
    color: "var(--web-title-text-color)",
    fontFamily: 'Roboto Slab'
  },

  cancelButton: {
    backgroundColor: "transparent",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "10px 20px",
    cursor: "pointer",
  },

  row: {
    display: 'flex',
    flexWrap: 'wrap', // Allow wrapping to the next row
    columnGap: '40px', // Gap between items (both horizontal and vertical)
    rowGap: '15px',
    padding: '16px 11px',
    border: '1px #EFF0F4 solid',
    borderBottom: '2px #060606 solid',
    // justifyContent: 'space-between', // Distribute items evenly
  },

  staticField: {
    // flex: '1 1 calc(25% - 70px)', // Adjusts for 4 items per row with gaps
    minWidth: '200px', // Minimum width of each item
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  label: {
    fontSize: "12px",
    marginBottom: "2px",
    color: "#767676",
    fontFamily: 'Roboto',
    fontWeight: '400'
  },
  staticValue: {
    fontSize: "14px",
    fontWeight: "400",
    color: '#060606',
    fontFamily: 'Roboto'
  },

  labaleStyle: {
    fontSize: '12px',
    marginBottom: '5px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    color: 'rgb(52, 60, 68)'
  },
  card: {
    minWidth: '25%',
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    marginTop: '25px',
    flex: 'auto',
    maxWidth: 300,
    height:'fit-content'
  },
  card2: {
    minWidth: '40%',
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    flex: 'auto',
    maxWidth: 300
  },
  heading: {
    fontSize: '18px',
    fontWeight: 400,
    paddingBottom: '20px',
    fontFamily: 'Roboto slab',
    // paddingTop: '19px',
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '10px',
    borderRadius: '8px'
  },
  cardLable: {
    color: '#505470',
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: '14px'
  },
  cardAmount: {
    color: '#060606',
    fontFamily: 'Roboto',
    fontWeight: '700',
    fontSize: '16px'
  },

  headerContainer: {
    display: 'flex',
    alignItems: 'center', // Vertically align items
  },
  header: {
    fontSize: "22px",
    color: "#060606",
    marginBottom: "10px",
    fontWeight: 500,
    // fontFamily: 'Montserrat',
    //   marginLeft:'20px'
  },
  categoryHeader: {
    color: '#1F384C',
    fontSize: 26,
    fontFamily: 'Roboto Slab',
    fontWeight: 500,
    paddingBottom: 20
},
};

export default InvoiceAccountClientInformationScreen